import AbstractPageBaseController from '../../../modules/core/abstracts/controllers/page-controller';

export default class AbstractCompanySettingsPageController extends AbstractPageBaseController {
    constructor($scope, $injector) {
        super($scope, $injector);

        this.company = null;
        this.user = null;
        this.loading = true;
    }

    $onInit() {
        if (this.stateParams.company && this.stateParams.user) {
            this.company = this.stateParams.company;
            this.user = this.stateParams.user;
            this._handleUserAndCompanyLoaded();
        } else {
            this._loadUserAndCompany()
        }
    }

    _handleUserAndCompanyLoaded() {
        this.loading = false;
    }

    _loadUserAndCompany() {
        this.loading = true;
        this.api
            .get('auth/profile?include=company')
            .then(({data}) => {
                this.user = _.clone(data.data);
                delete this.user.company;
                this.company = _.get(data, 'data.company.data');

                this.stateParams.user = _.cloneDeep(this.user);
                this.stateParams.company = _.cloneDeep(this.company);

                this._handleUserAndCompanyLoaded();
            })
            .catch(e => this.alert.handle(e));
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/settings/controllers/abstract-company-controller.js